import { Route, Routes, Navigate } from 'react-router-dom';
import {
    VerifyInvitationController,
    AcceptInvitationController,
    ProductAcceptInvitationController,
} from './InvitationControllers';
import {
    LoginWithInvitation,
    LogoutAndNext,
    LogoutAndApply,
    SwitchAccount,
    SignupWithInvitation,
    InvitationErrorFallback,
} from './InvitationAuth';

export const InvitationRoutes = () => {
    return (
        <Routes>
            <Route index element={<VerifyInvitationController />} />
            <Route path="signin" element={<LoginWithInvitation />} />
            <Route path="accept" element={<AcceptInvitationController />} />
            <Route path="logout-and-signup" element={<LogoutAndNext />} />
            <Route path="switch-account" element={<SwitchAccount />} />
            <Route path="signup" element={<SignupWithInvitation />} />
            <Route path="error" element={<InvitationErrorFallback />} />
        </Routes>
    );
};

export const ProductInvitationRoutes = () => {
    return (
        <Routes>
            <Route index element={<ProductAcceptInvitationController />} />
            <Route path="logout-and-apply" element={<LogoutAndApply />} />
            <Route
                path="switch-account"
                element={
                    <SwitchAccount
                        heading="Switch account"
                        message="You've been invited to use Daylit, but you're signed in with a different email."
                    />
                }
            />
            <Route path="error" element={<InvitationErrorFallback />} />
        </Routes>
    );
};
